<template>
  <div data-view="verify-link">
    <component :is="componentName" :has-aside="false">
      <template v-slot:content>
        <v-row class="form-wrapper normal">
          <div class="verify-link-box">
            <h2>
              {{ $t('validating_email_link') }}
            </h2>
            <div>
              <v-progress-circular
                v-if="isLoading"
                color="secondary"
                indeterminate
                :width="4"
                :size="32"
              />
              <h4 v-else-if="hasError">
                {{ $t('email_link_error') }}
              </h4>
            </div>
          </div>
        </v-row>
      </template>
    </component>
  </div>
</template>

<script>
  import { isObj, isStr } from '../../utils';

  export default {
    data() {
      return {
        isLoading: false,
        hasError: false,
      };
    },
    computed: {
      isLogged() {
        return this.$store.getters['auth/isLogged'];
      },
      componentName() {
        return this.isLogged ? 'layout-logged-frame' : 'layout-auth-frame';
      },
    },
    created() {
      this.checkRouteParams();
    },
    methods: {
      checkRouteParams() {
        const { $route, verifyLink } = this;

        if (isObj($route.params) && isStr($route.params.key)) {
          verifyLink($route.params.key);
        }
      },
      verifyLink(hash) {
        if (!hash) {
          this.hasError = true;
          return;
        }

        const query = {
          hash,
        };

        this.isLoading = true;
        this.hasError = false;

        return this.$store
          .dispatch('reports/verifyLink', query)
          .then((res) => {
            const { data } = res.data;
            this.isLoading = false;

            if (isStr(data)) {
              // calling router push with empty function
              // to magically fix "Uncaught (in promise)"
              this.$router.push(data, () => {});
            }

            return data;
          })
          .catch((err) => {
            this.isLoading = false;
            this.hasError = true;

            return err;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
@use '../../assets/styles/theme' as *;

[data-view='verify-link'] {
  .layout.form-wrapper {
    height: calc(100vh - 250px);
    justify-content: center;
    align-items: center;
  }

  .verify-link-box {
    height: 100px;
    text-align: center;

    h2 {
      margin-bottom: 30px;
    }

    h4 {
      color: #8f8f8f;
      font-weight: 500;
    }

    a:link {
      text-decoration: none;
    }
  }
}
</style>
